import React from 'react'

const ActionAnalyzerViewResult = ({result}) => {
  const formatArray = (arr) => {
    if (!arr || arr.length === 0) return '-';
    return Array.isArray(arr) ? arr.join(', ') : arr;
  };

  return (
    <div className="mt-4 overflow-x-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Actions Information */}
        <div className="space-y-4">
          {result?.actions?.map((action, index) => (
            <div key={index} className="card bg-base-100 shadow-sm">
              <div className="card-body p-4">
                <div className="flex justify-between items-start mb-2">
                  <h3 className="card-title text-lg">Action {index + 1}</h3>
                  <div className="flex gap-2">
                    <span className={`px-2 py-0.5 rounded-full text-xs ${
                      action.urgency === 'immediate' ? 'bg-error/20 text-error' :
                      action.urgency === 'high' ? 'bg-warning/20 text-warning' :
                      'bg-info/20 text-info'
                    }`}>
                      {action.urgency}
                    </span>
                    <span className="px-2 py-0.5 rounded-full text-xs bg-success/20 text-success">
                      {action?.confidence * 100}%
                    </span>
                  </div>
                </div>

                <table className="table table-zebra w-full">
                  <tbody>
                    <tr>
                      <td className="font-medium">Action</td>
                      <td>{action?.action}</td>
                    </tr>
                    <tr>
                      <td className="font-medium">Context</td>
                      <td>{action?.context}</td>
                    </tr>
                    <tr>
                      <td className="font-medium">Category</td>
                      <td className="capitalize">{action?.category}</td>
                    </tr>
                    <tr>
                      <td className="font-medium">Evidence</td>
                      <td>{formatArray(action?.evidence)}</td>
                    </tr>
                    <tr>
                      <td className="font-medium">Sentiment</td>
                      <td className="capitalize">{action?.sentiment}</td>
                    </tr>
                    <tr>
                      <td className="font-medium">Importance</td>
                      <td className="capitalize">{action?.frequency_importance_score}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>

        {/* Recommendations */}
        <div className="space-y-4">
          <div className="card bg-base-100 shadow-sm">
            <div className="card-body p-4">
              <h3 className="card-title text-lg mb-2">Recommendations</h3>
              
              {/* Immediate Recommendations */}
              <div className="p-2 bg-base-200 rounded-lg mb-3">
                <h4 className="font-medium text-error mb-2">Immediate Actions</h4>
                <ul className="list-disc list-inside space-y-1">
                  {result?.recommendations?.immediate?.map((rec, index) => (
                    <li key={index} className="text-sm">{rec}</li>
                  ))}
                </ul>
              </div>

              {/* Short Term Recommendations */}
              <div className="p-2 bg-base-200 rounded-lg mb-3">
                <h4 className="font-medium text-warning mb-2">Short Term Actions</h4>
                <ul className="list-disc list-inside space-y-1">
                  {result?.recommendations?.short_term?.map((rec, index) => (
                    <li key={index} className="text-sm">{rec}</li>
                  ))}
                </ul>
              </div>

              {/* Long Term Recommendations */}
              <div className="p-2 bg-base-200 rounded-lg">
                <h4 className="font-medium text-info mb-2">Long Term Actions</h4>
                <ul className="list-disc list-inside space-y-1">
                  {result?.recommendations?.long_term?.map((rec, index) => (
                    <li key={index} className="text-sm">{rec}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionAnalyzerViewResult;